// extracted by mini-css-extract-plugin
export default {"corner_img":"CornerImage_corner_img__6Xwt6"};